import React from 'react';
import { Box } from '@mui/material';
import { OCR_GUIDE_ROW_HEIGHT } from './AuditDynamicFormConstants';

type VendingSalesFormTableHeaderProps = {
  reportType: 'vending_sales' | 'vending_inventory';
};

const VendingSalesFormTableHeader: React.FC<VendingSalesFormTableHeaderProps> = React.memo(({ reportType }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: reportType === 'vending_inventory'
        ? '64px minmax(196px, 1.08fr) 96px 104px 20px 20px'
        : '72px 1fr 112px 132px 36px',
      alignItems: 'center',
      height: OCR_GUIDE_ROW_HEIGHT,
      minHeight: OCR_GUIDE_ROW_HEIGHT,
      maxHeight: OCR_GUIDE_ROW_HEIGHT,
      px: 0,
      py: 0,
      color: '#2b2825',
      fontFamily: 'inherit',
      borderBottom: '1px dashed #d6b982',
      columnGap: reportType === 'vending_inventory' ? 0.25 : 1.5,
    }}
  >
    <Box sx={{ textAlign: 'center', fontSize: 17, fontWeight: 800, fontFamily: 'inherit' }}>
      BIN
    </Box>
    <Box sx={{ textAlign: reportType === 'vending_inventory' ? 'left' : 'center', fontSize: 17, fontWeight: 800, fontFamily: 'inherit', whiteSpace: 'nowrap', pl: reportType === 'vending_inventory' ? 1 : 0 }}>
      {reportType === 'vending_inventory' ? 'GAME - PACK' : 'GAME'}
    </Box>
    <Box sx={{ textAlign: 'right', fontSize: 17, fontWeight: 800, fontFamily: 'inherit' }}>
      {reportType === 'vending_inventory' ? 'QTY' : 'COUNT'}
    </Box>
    <Box sx={{ textAlign: 'right', fontSize: 17, fontWeight: 800, fontFamily: 'inherit' }}>
      {reportType === 'vending_inventory' ? 'VALUE' : 'AMOUNT'}
    </Box>
    {reportType === 'vending_inventory' && (
      <Box />
    )}
    <Box />
  </Box>
));

VendingSalesFormTableHeader.displayName = 'VendingSalesFormTableHeader';

export default VendingSalesFormTableHeader;
